module.exports = __webpack_public_path__ + "img/bg.cc2f744e.png";